exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-alert[data-v-7a58b39e]{font-size:14px}", ""]);

// exports
